import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { APP_TABS, isActivePath } from './shell/nav';

// Phone bottom tab bar — the signed-in primary nav under lg. Labels only, on a
// translucent hairline bar. Desktop uses the rail instead.
const BottomNav = () => {
  const { pathname } = useLocation();

  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-5 items-stretch chrome-glass border-t border-line"
      style={{ height: 'calc(60px + env(safe-area-inset-bottom))', paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Primary"
    >
      {APP_TABS.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          className={`grid place-items-center min-w-0 text-sm font-medium transition-colors ${
            isActivePath(pathname, tab.to) ? 'text-fg' : 'text-fg-3 hover:text-fg'
          }`}
        >
          <span className="leading-none">{tab.label}</span>
        </Link>
      ))}
    </nav>
  );
};

export default BottomNav;
